// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #7b1fa2;
}

.container {
  margin-top: 100px;
  margin-bottom: 100px;
}

.carousel-inner img {
  width: 100%;
  /* height: 100%; */
  height: 350px !important;
}

#custCarousel .carousel-indicators {
  position: static;
  margin-top: 20px;
}

#custCarousel .carousel-indicators > li {
  width: 100px;
}

#custCarousel .carousel-indicators li img {
  display: block;
  opacity: 0.5;
}

#custCarousel .carousel-indicators li.active img {
  opacity: 1;
}

#custCarousel .carousel-indicators li:hover img {
  opacity: 0.75;
}

.carousel-item img {
  width: 80%;
}
.tooltiptext p {
  font-size: xx-small;
}
.bottom-fixed-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #fff; /* Background color for the button container */
  z-index: 1000; /* Ensure it stays above other elements */
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow for better visibility */
}

.bottom-fixed-btn .btn {
  flex: 1 1; /* Ensure buttons take equal width */
  margin: 0; /* Remove default margin */
  border-radius: 0; /* Remove border radius for a seamless look */
  text-align: center;
  padding: 10px; /* Optional padding for aesthetics */
}

/* Mobile-specific adjustments */
@media (max-width: 768px) {
  .bottom-fixed-btn {
    flex-direction: row; /* Stack buttons vertically on smaller screens */
  }

  .bottom-fixed-btn .btn {
    width: 100%; /* Ensure buttons take full width */
    margin-bottom: 5px; /* Add spacing between buttons */
  }

  .bottom-fixed-btn .btn:last-child {
    margin-bottom: 0; /* Remove margin for the last button */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/event/EventCardLarge.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,sBAAsB,EAAE,8CAA8C;EACtE,aAAa,EAAE,yCAAyC;EACxD,yCAAyC,EAAE,0CAA0C;AACvF;;AAEA;EACE,SAAO,EAAE,oCAAoC;EAC7C,SAAS,EAAE,0BAA0B;EACrC,gBAAgB,EAAE,6CAA6C;EAC/D,kBAAkB;EAClB,aAAa,EAAE,oCAAoC;AACrD;;AAEA,gCAAgC;AAChC;EACE;IACE,mBAAmB,EAAE,gDAAgD;EACvE;;EAEA;IACE,WAAW,EAAE,mCAAmC;IAChD,kBAAkB,EAAE,gCAAgC;EACtD;;EAEA;IACE,gBAAgB,EAAE,sCAAsC;EAC1D;AACF","sourcesContent":["body {\n  background-color: #7b1fa2;\n}\n\n.container {\n  margin-top: 100px;\n  margin-bottom: 100px;\n}\n\n.carousel-inner img {\n  width: 100%;\n  /* height: 100%; */\n  height: 350px !important;\n}\n\n#custCarousel .carousel-indicators {\n  position: static;\n  margin-top: 20px;\n}\n\n#custCarousel .carousel-indicators > li {\n  width: 100px;\n}\n\n#custCarousel .carousel-indicators li img {\n  display: block;\n  opacity: 0.5;\n}\n\n#custCarousel .carousel-indicators li.active img {\n  opacity: 1;\n}\n\n#custCarousel .carousel-indicators li:hover img {\n  opacity: 0.75;\n}\n\n.carousel-item img {\n  width: 80%;\n}\n.tooltiptext p {\n  font-size: xx-small;\n}\n.bottom-fixed-btn {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  background-color: #fff; /* Background color for the button container */\n  z-index: 1000; /* Ensure it stays above other elements */\n  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow for better visibility */\n}\n\n.bottom-fixed-btn .btn {\n  flex: 1; /* Ensure buttons take equal width */\n  margin: 0; /* Remove default margin */\n  border-radius: 0; /* Remove border radius for a seamless look */\n  text-align: center;\n  padding: 10px; /* Optional padding for aesthetics */\n}\n\n/* Mobile-specific adjustments */\n@media (max-width: 768px) {\n  .bottom-fixed-btn {\n    flex-direction: row; /* Stack buttons vertically on smaller screens */\n  }\n\n  .bottom-fixed-btn .btn {\n    width: 100%; /* Ensure buttons take full width */\n    margin-bottom: 5px; /* Add spacing between buttons */\n  }\n\n  .bottom-fixed-btn .btn:last-child {\n    margin-bottom: 0; /* Remove margin for the last button */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
